<template>
  <section >
    <div>
      <v-tabs
        scrollable
        v-model="active"
        icons-and-text
      >
      <v-tabs-bar class="primary">
      <v-tabs-slider color="accent"></v-tabs-slider>
    
      <v-tabs-item
                  v-for="tab in tabs"
                  :key="tab"
                  :href="'#' + tab"
                  ripple
                  class="tab-leccion-derecha"
                  >
      <p class="estilo-p">{{ tab }}</p>
      </v-tabs-item>
    </v-tabs-bar>
    <v-tabs-items>
                <v-tabs-content
                v-for="tab in tabs"
                :key="tab"
                :id="tab"
                >
                <v-flex class="ml-0 "  v-if="tab === 'Listado'">
                  <v-card class="" >
                    <v-layout row >
                        <v-flex xs10  sm10  md6 lg6 xl6 class="header-table mt-3">
                          <v-flex offset-xs1 offset-sm1 offset-md1 offset-lg1 offset-xl1 >
                            <p class="display-1">Listado de Rendidores</p>
                            
                          </v-flex>
                        </v-flex>
                        <v-flex xs10  sm10  md6 lg6 xl6  class="header-table mt-3">
                          <v-flex offset-xs1 offset-sm5 offset-md7 offset-lg8 offset-xl8 >
                            <v-btn color="primary"  offset-xs8 offset-sm8 offset-md8 offset-lg8 offset-xl8 ><v-icon>arrow_back</v-icon>Volver</v-btn>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-text-field
                        append-icon="search"
                        label="Buscador"
                        single-line
                        hide-details
                        v-model="search"
                      ></v-text-field>
                    </v-card-title>
                    <v-flex mx-5>
                    <v-data-table 
                        v-bind:headers="headers"
                        v-bind:items="members"
                        v-bind:search="search"
                        rows-per-page-text = "Filas por Pagina"
                        no-data-text="No hay Pruebas de Miembros"
                      >
                      <template slot="items" slot-scope="props">
                        <td class="py-2"> <v-avatar><img height="40" :src="props.item.user.avatar"/></v-avatar></td>
                        <td class="text-xs-center primary--text body-1">{{ props.item.user.nombre}} {{props.item.user.apellido }}</td>

                        <!--<td v-if="props.item.member_qualification.length == 0 ||props.item.member_qualification[0].qualification === undefined" class="text-xs-center">{{ props.item.member_qualification[0].qualification.qualification_surrender_date }}</td>
                        <td v-else class="text-xs-center">Aun no responde</td>
                        <td class="text-xs-center">
                           <v-icon color="success">check_circle</v-icon>
                           <span>calificado</span>

                           <v-icon color="warning">notification_important</v-icon>
                           <span>espderando Calificación</span>
                        </td>
                        <!-- member_qualification[0] CARGAR POR LA CALIFICACION-->
                        <!--
                        <td v-if="props.item.member_qualification.length == 0" class="text-xs-center">{{props.item.member_qualification[idEvaluacion-1].qualificationEstudent}}</td>
                        <td v-else class="text-xs-center">Aun no responde</td>
                        -->
                        <td class="text-xs-center">
                          <v-btn  icon color="accent" class="white--text"  @click="setCurrentUser(props.item)" >
                            <v-icon>spellcheck</v-icon>
                          </v-btn>
                        </td>
                      </template>
                      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                        Desde {{ pageStart }} a {{ pageStop }}
                      </template>
                    </v-data-table>
                    </v-flex>
                  </v-card>
                </v-flex>
                <template v-if="tab === 'Resultados'">
                <v-layout class="my-4" row> 
                  <v-flex xs4>
                    <p class="display-1 ml-2">Rendimiento del curso</p>
                  </v-flex>
                <v-flex xs8  class="mr-1"  >
                  <v-card light color="grey lighten-4">
                  <div><chartjs-doughnut v-bind:labels="labels" v-bind:datasets="datasets" v-bind:option="option"></chartjs-doughnut></div>
                  </v-card>
                </v-flex>
                </v-layout>
                <v-layout class="my-4" row > 
                  <v-flex xs4>
                    <p class="display-1 ml-2">Pregunta con mejor desempeño</p>
                  </v-flex>
                <v-flex xs8  class="mr-1"  >
                  <v-card light color="grey lighten-4">
                  <div><chartjs-doughnut v-bind:labels="labels" v-bind:datasets="datasets" v-bind:option="option"></chartjs-doughnut></div>
                  </v-card>
                </v-flex>                
                </v-layout>
                <v-layout class="my-4" row > 
                  <v-flex xs4>
                    <p class="display-1 ml-2">Pregunta con peor desempeño</p>
                  </v-flex>
                <v-flex xs8  class="mr-1"  >
                  <v-card light color="grey lighten-4">
                  <div><chartjs-doughnut v-bind:labels="labels" v-bind:datasets="datasets" v-bind:option="option"></chartjs-doughnut></div>
                  </v-card>
                </v-flex>                
                </v-layout>
                </template>
                </v-tabs-content>
    </v-tabs-items>
    </v-tabs>
      </div>
      <v-dialog v-model="dialogCalificar" fullscreen hide-overlay transition="dialog-bottom-transition" :overlay=false>
        <v-card mt-5>
          <v-toolbar dark color="primary">
          <v-btn icon dark @click="resetAnswer()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Corrección de Prueba</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="dialog = false">Guardar 
              <v-icon class="mx-1" color="white">save</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
          <v-flex xs9 sm9 md9 lg9 xl9 offset-xs2  mt-5 pt-5>
            
        <p class="headline grey--text" style="text-transform:uppercase;" >{{evaluacion.section.section_title}}</p>
        <!-- {{ curso.cource_title }} -->
        <p class="title grey--text"> CURSO: {{ evaluacion.section.unity.course.cource_title }}</p>
        <p class="title grey--text"> Alumno: <span class="secondary--text">{{memberAux.user.nombre+' '+memberAux.user.apellido}}</span></p>
      <v-divider></v-divider>
      <!-- {{ prueba.questions[contadorPregunta].question_text }} -->
      <template v-for="(item, index) in answerForUser.questions">
        <v-flex>
        <p class="display-1 primary--text">{{item.question_text}}</p>
        <v-flex row v-if="item.type_question_id === 5">
        <v-layout >

            <v-flex  xs10 >
              <v-layout row wrap class="bordes">
                <v-flex xs6  class="secondary">
                    <p class="subheading text-xs-center mt-3 white--text" >Nombre</p>
                  </v-flex>
                  <v-flex xs6 class="secondary  ">
                    <p class="subheading text-xs-center mt-3 white--text">Dato Maestro</p>
                </v-flex >
                <v-flex xs12 class="py-0 borde-derecha-abajo " v-for="item in encabezado.filas" :key="item.id" style="margin-bottom: 0px !important;">
                  <v-layout row wrap>
                                      <v-flex xs6>
                    <v-text-field
                      name="input-1-3"
                      color="accent"
                      single-line
                      disabled
                      solo
                      v-model="item.codigo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                      <v-text-field
                      name="input-1-3"
                      color="accent"
                      single-line
                      disabled
                      solo
                      v-model="item.datoM"
                    ></v-text-field>
                  </v-flex>
                  </v-layout>


                </v-flex> 
                  
              </v-layout>
            </v-flex>

            <v-flex xs2 mx-1>
               <v-flex xs12 class="primary">
                <p class="subheading text-xs-center mt-3 white--text">Puntaje</p>
            </v-flex >
            
            <v-flex xs12 class="py-0 borde-derecha-abajo" v-for="index3 in encabezado.filas.length" :key="index3" style="margin-bottom: 0px !important;">
              <v-text-field
                name="input-1-3"
                color="accent"
                single-line
                solo
                type="number"
                :max="encabezado.puntaje"
                min=0
                v-model="puntajeEncabezadoObtenido[index3-1]"
                @change="puntajeEncabezadoCalculo()"
              ></v-text-field>
              
            </v-flex>
            </v-flex>

            
        </v-layout>
        <v-subheader class="secondary--text ml-3 pt-4" >Puntaje Encabezado {{encabezado.puntajeObtenido}}/{{encabezado.puntaje}}</v-subheader>
        </v-flex>

        <p class="headline ">Respuesta de usuario</p>
        <v-flex v-if="item.type_question_id === 1">
          <v-layout row wrap>
            <v-text-field
              name="input-1-3"
              autofocus
              single-line
              solo
              disabled
              class=""
              v-model="item.answers[0].response"
            ></v-text-field>
          </v-layout>
        </v-flex>
        <v-flex v-if="item.type_question_id === 2">
           <v-layout row wrap >
            <v-text-field
              name="input-7-1"

              persistent-hint
              multi-line
              autofocus
              solo
              disabled
              v-model="item.answers[0].response"
            ></v-text-field>
          </v-layout>
        </v-flex>
        <v-flex v-if="item.type_question_id === 3">
          <v-layout row wrap>
            <v-flex >
           <v-radio-group v-model="item.eleccion" :mandatory="false" disabled>
            <template v-for="(alternativa, index2) in item.answers"  >
              <v-layout row>
              <v-radio class="color-primary "  disabled :label="alternativa.response_option.response_options_test" :value="alternativa.id"></v-radio>
              <!--<div v-if="evaluacion.questions[index].response_option[index2].response_option_correct === 1 && alternativa.response==='true'">
                <v-icon color="success">check_circle</v-icon>
                
              </div>
              <div v-else><v-icon color="error">cancel</v-icon></div><-->
              </v-layout>
            </template>
          </v-radio-group>
          </v-flex>
          <v-flex xs1>
          <!--  iconos para correctar o incorrecta -->
          <div align="" class="pt-5" v-if="correctasOpciones1[index].estado === true">
            <v-icon x-large color="success">check_circle</v-icon>
          </div>
          <div align="" class="pt-5" v-else>
            <v-icon x-large color="error">cancel</v-icon>
          </div>
          
           </v-flex>
          </v-layout>

        </v-flex>
        <v-flex v-if="item.type_question_id === 4">
          <v-layout row wrap>
            <v-flex >
          <v-flex xs12 v-for="(alternativa, index2) in item.answers " :key="alternativa.id">
            <v-layout row>
            <v-checkbox  :mandatory="false" disabled class="color-primary " :label="alternativa.response_option.response_options_test" v-model="item.eleccion" :value="alternativa.id">
              <v-icon color="success">check_circle</v-icon>
              </v-checkbox>              
            
              <div v-if="(evaluacion.questions[index].response_option[index2].response_option_correct === 1 && alternativa.response==='true') || (evaluacion.questions[index].response_option[index2].response_option_correct === 0 && alternativa.response==='false') ">
                <v-icon color="success">check_circle</v-icon>
              </div>
              <div v-else><v-icon color="error">cancel</v-icon></div>
            </v-layout>
              
          </v-flex>
          </v-flex>
          <!--
          <v-flex xs1>
          <div align="" class="pt-5" v-if="false">
            <v-icon x-large color="success">check_circle</v-icon>
          </div>
          <div align="" class="pt-5" v-else>
            <v-icon x-large color="error">cancel</v-icon>
          </div>
           </v-flex>
           -->
          </v-layout>
        </v-flex>
        <v-flex v-if="item.type_question_id === 5">

          <v-layout row>
            <v-flex xs10>
              <v-layout row wrap class="bordes">
            <v-flex xs6  class="accent">
                <p class="subheading text-xs-center mt-3 white--text" >Transacción</p>
              </v-flex>
              <v-flex xs6 class="accent">
                <p class="subheading text-xs-center mt-3 white--text">Código</p>
            </v-flex >
            <v-flex xs6 class="py-0 borde-derecha-abajo " v-for="celda in item.answers" :key="celda.id" style="margin-bottom: 0px !important;">
              <v-text-field
                name="input-1-3"
                color="accent"
                single-line
                solo
                disabled
                v-model="celda.response"
              ></v-text-field>
            </v-flex>
          </v-layout>
            </v-flex>
            <v-flex xs2 mx-1>
               <v-flex xs12 class="primary">
                <p class="subheading text-xs-center mt-3 white--text">Puntaje</p>
            </v-flex >
            <v-flex xs12 class="py-0 borde-derecha-abajo" v-for="(item,index3) in puntajeSapAux[index]" :key="index3"  style="margin-bottom: 0px !important;">

              <v-text-field
                name="input-1-3"
                color="accent"
                single-line
                solo
                type="number"
                
                min=0
                v-model="puntajeSapAux[index][index3]"
                @change="puntajeSapCalculo2(index)"
              ></v-text-field>
              
            </v-flex>
            </v-flex>
          </v-layout>
          
        </v-flex>
        <v-subheader v-if="item.type_question_id === 3 || item.type_question_id === 4" class="secondary--text ml-3 pt-4" >Puntaje {{correctasOpciones1[index].puntaje}}/{{item.questions_point}}</v-subheader>
        <v-layout class="mt-3" row  v-else>
          <v-subheader class="secondary--text ml-3 pt-4" >Puntaje {{preguntasPuntajes[index]}}/{{item.questions_point}}</v-subheader>
          
          <v-layout row v-if="item.type_question_id !== 5">
            <v-subheader class="secondary--text ml-3 pt-4" >Asignar Puntaje</v-subheader>
          <v-flex xs3>
            <v-text-field class="mt-3"
              name="input-1-3"
              type="number"
              single-line
              solo
              :max="item.questions_point"
              min=0
              append-icon="exposure_plus_1"
              color="white"
              label="Puntaje Pregunta"
              @change="actualizarPuntajes()"
              v-model="preguntasPuntajes[index]"
              ></v-text-field>
          </v-flex>
          </v-layout>
        </v-layout>
        
        </v-flex>
      </template>
      <v-divider class="my-5"></v-divider>
      </v-flex>
        <h3 class="primary--text text-md-center">Resultados</h3>
          <v-layout justify-center>
            
            
          <v-flex xs4 class="px-3 my-2">
            <v-card 
            color="accent"
            height="100">
            <h4 class="white--text text-md-center pt-2">Puntaje Obtenido</h4>
            <h5 class=" white--text text-md-center">{{puntajeTotal+encabezado.puntajeObtenido}}</h5></v-card>
          </v-flex>
          <!--
          <v-flex xs4 class="px-3 my-2">
            <v-card color="accent"
            height="100"
            ><h4 class="white--text text-md-center pt-2">Calificación</h4>
            <h5 class=" white--text text-md-center">{{(puntajeTotal*7)/puntajeIdeal}}</h5></v-card>
          </v-flex>
          -->
          
          </v-layout>
          
          <div align="right" class="mt-5">
      <v-btn color="primary" class="white--text mr-5"  @click="savePoits(memberAux.user.id)">Guardar 
              <v-icon class="mx-1" color="white">save</v-icon>
            </v-btn>

          </div>
           
          <!--
       <v-toolbar dark color="primary">
         <h3 class="white--text">Puntaje Total {{puntajeTotal}}</h3>
         <v-divider class="px-3"></v-divider>
         <br>
         <h3 class="white--text">Puntaje Ideal {{puntajeIdeal}}</h3>
       </v-toolbar>-->
        </v-card>
      </v-dialog>
  <v-snackbar
      :timeout="timeout"
      :color="colorSnackbar"
      v-model="snackbar"
    >
    <v-icon dark>check_circle</v-icon>
      {{ textSnackbar }}
      <v-btn dark flat @click.native="snackbar = false">X</v-btn>
  </v-snackbar>


  </section>
</template>

<script>
import { evaluationTypeService } from '@/services/prueba/EvaluationType.service'
import { institutionService } from '@/services/Institution.service'
import { getUsersInCourseService } from '@/services/Miembro/GetUsersInCourses.service'
import { Bar } from 'vue-chartjs'
// import { getAnswerPerUserService } from '@/services/prueba/GetAnswerPerUser.service'
import { testService } from '@/services/Test.service'
// import { getMemberQualificationService } from '@/services/Miembro/GetMemberQualification.service'
// import { getAnswerPerUserService } from '@/services/prueba/GetAnswerPerUser.service'
import { getAnswerIdUserService } from '@/services/prueba/GetAnswerIdUser.service'
import { pointService } from '@/services/Calificacion/Points.service'
// import { getMemberQualificationService } from '@/services/Miembro/GetMemberQualification.service'

export default {
  data () {
    return {
      rules: {
        max: value => value >= 3 || 'mal',
        min: value => value <= 0 || 'min 20 characters'
      },
      tab: null,
      tabs: [
        'Listado'
      ],
      extends: Bar,
      active: null,
      puntaje: [{
        user: {
          nombre: '',
          puntaje: 0
        }
      }],
      labels: ['Manzana', 'Naranja', 'Piña'],
      datasets: [
        {
          data: [40, 35, 25],
          backgroundColor: ['red', 'yellow', 'purple']
        }
      ],
      option: {
        title: {
          display: true,
          position: 'bottom',
          text: 'Frutas'
        }
      },
      instituciones: [],
      institucion: {},
      evaluacionTipos: [],
      evaluacionTipo: {},
      currentInstitucion: {},
      dialogCalificar: false,
      dialogEditInsitucion: false,
      idCurso: 0,
      tmp: '',
      search: '',
      pagination: {},
      snackbar: false,
      members: [],
      members2: {
        id: 0,
        course_id: 0,
        user_id: 0,
        type_user_id: 0,
        user: [{
          id: 1,
          nombre: 'J',
          apellido: 'a',
          rut: '1111111111',
          avatar: 'http://localhost:8000/storage/avatars/avatardefault.png'
        }]
      },
      colorSnackbar: '',
      timeout: 6000,
      textSnackbar: '',
      headers: [
        { text: '', align: '', value: '' },
        { text: 'Nombre', align: 'center', value: 'nombre' },
        { text: 'Calificar', align: 'center', value: 'calificar' }
      ],
      answerForUser: {},
      prueba: {
        preguntas: [{
          questions_point: 0
        }]
      },
      evaluacion: {
        questions: [{
          question_text: '',
          response_option: [{
            response_options_test: ''
          }]
        }],
        section: {
          section_title: '',
          unity: {
            course: {
              cource_title: ''
            }
          }
        }
      },
      idEvaluacion: 0,
      cantidadPreguntas: 0,
      memberAux: {
        user: {
          nombre: '',
          apellido: ''
        }
      },
      correctasOpciones1: [],
      correctasCasillas1: [],
      preguntasTodas: [],
      preguntasPuntajes: [],
      preguntasPuntajes1: [],
      puntajeTotal: 0,
      puntajeIdeal: 0,
      mensaje: 'vacio mientras',
      puntajeSap: [],
      puntajeSapAux: [],
      filaSapAux: [],
      encabezado: {
        puntajeObtenido: 0,
        puntaje: 0
      },
      puntajeObtenido: 0,
      puntajeEncabezadoObtenido: []
    }
  },
  methods: {
    loadInstituciones () {
      let vm = this
      institutionService.query().then(data => {
        vm.instituciones = data.body
      })
    },
    loadEvaluacionesTipo () {
      let vm = this
      evaluationTypeService.query().then(data => {
        vm.evaluacionTipos = data.body
      })
    },
    verLeccion (id) {
      this.$router.push({name: 'showLesson', params: {id: id}})
    },
    loadEvaluacion () {
      let vm = this
      testService.getById(vm.idEvaluacion).then(data => {
        vm.evaluacion = data.body
        // vm.correctasOpciones1 = data.body.questions
        vm.cantidadPreguntas = data.body.questions.length
        vm.idCurso = vm.evaluacion.section.unity.course_id
        // vm.loadAnswer()
        vm.loadMemberGet()
      })
    },
    loadAnswer (idUser) {
      let vm = this
      getAnswerIdUserService.getByIdEvaluacion(vm.idEvaluacion, idUser).then(data => {
        if (data.body.tipoHeader === 1) {
          var myJSON = JSON.parse(data.body.header.respuesta_encabezado)
          vm.encabezado = myJSON
        }
        vm.answerForUser = data.body
        vm.correctasOpciones()
        vm.correctasCasilla()
        vm.calculoPuntajesSapFilas()
        // vm.loadMemberGet()
      })
    },
    loadmiembrosDelCursoNotas () {
      let vm = this
      getUsersInCourseService.getById(vm.idCurso).then(data => {
        vm.miembrosNotas = data.body
      })
    },
    resetAnswer () {
      let vm = this
      vm.dialogCalificar = false
      vm.answerForUser = {}
      vm.correctasOpciones1 = []
      vm.correctasCasillas1 = []
    },
    submitEvaluationType (model) {
      let vm = this
      evaluationTypeService.save(model).then(data => {
        vm.dialogAddInsitucion = false
        vm.mensajeToast('success', true, 'Tipo de evaluación guardada con exito')
        vm.evaluacionTipos = data.body
      }, response => {
        vm.mensajeToast('error', true, 'Error al guardar Tipo de evaluación')
      })
    },
    deleteInstitution (id) {
      let vm = this
      institutionService.destroy(id).then(data => {
        vm.mensajeToast('success', true, 'Institucion eliminada con exito')
        vm.instituciones = data.body
      }, response => {
        vm.mensajeToast('error', true, 'Error al eliminar Institucion')
      })
    },
    editInstitution (id, model) {
      let vm = this
      institutionService.update(id, model).then(data => {
        vm.dialogEditInsitucion = false
        vm.mensajeToast('success', true, 'Institucion editada con exito')
        vm.instituciones = data.body
      }, response => {
        vm.mensajeToast('error', true, 'Error al editar Institucion')
        vm.dialogEditInsitucion = false
      })
    },
    loadMemberGet () {
      let vm = this
      getUsersInCourseService.getById(vm.idCurso).then(data => {
        vm.members = data.body
      })
    },
    setCurrentInstitucion (institucion) {
      let vm = this
      vm.currentInstitucion = institucion
    },
    setCurrentUser (user) {
      let vm = this
      vm.dialogCalificar = true
      vm.memberAux = user
      vm.loadAnswer(vm.memberAux.user.id)
    },
    mensajeToast (color, snack, texto) {
      let vm = this
      vm.colorSnackbar = color
      vm.snackbar = snack
      vm.textSnackbar = texto
    },
    correctasOpciones () {
      let vm = this
      var preguntaCorregida = {
        estado: false,
        puntaje: 0
      }
      for (var index in vm.evaluacion.questions) {
        if (vm.evaluacion.questions[index].type_question.id === 3) {
          for (var index2 in vm.evaluacion.questions[index].response_option) {
            if (vm.evaluacion.questions[index].response_option[index2].response_option_correct === 1 && vm.answerForUser.questions[index].answers[index2].response === 'true') {
              preguntaCorregida.estado = true
              preguntaCorregida.puntaje = vm.evaluacion.questions[index].questions_point
            }
          }
        }
        vm.correctasOpciones1.push(preguntaCorregida)
        preguntaCorregida = {
          estado: false,
          puntaje: 0
        }
      }
    },
    correctasCasilla () {
      let vm = this
      var preguntaCorregida = {
        // estado: false,
        puntaje: 0
      }
      var point = 0
      var buenas = 0
      for (var index in vm.evaluacion.questions) {
        if (vm.evaluacion.questions[index].type_question.id === 4) {
          // vm.
          for (var index2 in vm.evaluacion.questions[index].response_option) {
            if ((vm.evaluacion.questions[index].response_option[index2].response_option_correct === 1 && vm.answerForUser.questions[index].answers[index2].response === 'true') || (vm.evaluacion.questions[index].response_option[index2].response_option_correct === 0 && vm.answerForUser.questions[index].answers[index2].response === 'false')) {
              // preguntaCorregida.estado = true
              preguntaCorregida.puntaje = vm.evaluacion.questions[index].questions_point
              buenas++
            }
          }
        }
        // if (vm.evaluacion.questions[index].questions_point === 0)
        point = (buenas * vm.evaluacion.questions[index].questions_point) / vm.answerForUser.questions[index].answers.length
        vm.puntajeTotal = point + vm.puntajeTotal
        vm.puntajeIdeal = vm.evaluacion.questions[index].questions_point + vm.puntajeIdeal
        preguntaCorregida.puntaje = point
        vm.correctasCasillas1.push(point)
        vm.correctasOpciones1[index] = preguntaCorregida
        preguntaCorregida = {
          // estado: false,
          puntaje: 0
        }
        point = 0
        buenas = 0
      }
    },
    calculoPuntajesSapFilas () {
      let vm = this
      for (var index in vm.evaluacion.questions) {
        for (var index2 in vm.evaluacion.questions[index].response_option) {
          if (vm.evaluacion.questions[index].type_question.id === 5) {
            if (vm.evaluacion.questions[index].response_option[index2].type_response_id === 1) {
              var puntajeFila = 0
              vm.filaSapAux.push(puntajeFila)
            }
          } else {
            var puntajeFilaVacio = 0
            vm.filaSapAux.push(puntajeFilaVacio)
          }
        }
        vm.puntajeSapAux.push(vm.filaSapAux)
        vm.filaSapAux = []
      }
    },
    puntajeSapCalculo2 (index) {
      let vm = this
      var puntajeSapTotal = 0
      for (var i in vm.puntajeSapAux[index]) {
        if (vm.puntajeSap[i] !== '') {
          puntajeSapTotal = puntajeSapTotal + parseInt(vm.puntajeSapAux[index][i])
        }
      }
      vm.preguntasPuntajes[index] = puntajeSapTotal
      vm.correctasOpciones1[index].puntaje = puntajeSapTotal
      vm.actualizarPuntajes()
    },
    puntajeSapCalculo (index) {
      let vm = this
      var puntajeSapTotal = 0
      for (var i in vm.puntajeSap) {
        if (vm.puntajeSap[i] !== '') {
          puntajeSapTotal = puntajeSapTotal + parseInt(vm.puntajeSap[i])
        }
      }
      vm.preguntasPuntajes[index] = puntajeSapTotal
      vm.correctasOpciones1[index].puntaje = puntajeSapTotal
      vm.actualizarPuntajes()
    },
    puntajeEncabezadoCalculo () {
      let vm = this
      vm.encabezado.puntajeObtenido = parseInt(vm.encabezado.puntajeObtenido)
      var puntaje = 0
      for (var i in vm.puntajeEncabezadoObtenido) {
        if (vm.puntajeEncabezadoObtenido[i] !== '') {
          puntaje = puntaje + parseInt(vm.puntajeEncabezadoObtenido[i])
        }
      }
      vm.encabezado.puntajeObtenido = puntaje
      vm.actualizarPuntajes()
    },
    actualizarPuntajes () {
      let vm = this
      vm.preguntasPuntajes1 = []
      for (var index in vm.evaluacion.questions) {
        vm.preguntasPuntajes1.push(vm.correctasOpciones1[index].puntaje)
      }
      vm.puntajeTotal = 0
      for (var index2 in vm.preguntasPuntajes1) {
        if (vm.preguntasPuntajes[index2] === undefined) {
        } else {
          vm.preguntasPuntajes1[index2] = parseInt(vm.preguntasPuntajes[index2])
        }
        vm.puntajeTotal = vm.puntajeTotal + vm.preguntasPuntajes1[index2]
        vm.puntajeObtenido = vm.puntajeTotal + parseInt(vm.encabezado.puntajeObtenido)
      }
    },
    savePoits (idUser) {
      let vm = this
      var model = {
        user_id: 0,
        puntos: 0,
        puntajeMaximo: 0
      }
      model.qualification_id = vm.answerForUser.qualification_id
      model.course_id = vm.answerForUser.section.unity.course_id
      model.user_id = idUser
      model.puntos = vm.puntajeObtenido
      model.puntajeMaximo = vm.puntajeIdeal + parseInt(vm.encabezado.puntaje)
      pointService.update(vm.idEvaluacion, model).then(data => {
      })
      vm.dialogCalificar = false
      vm.puntajeIdeal = 0
      //  vm.puntajeTotal = 0
    }
  },
  mounted () {
    let vm = this
    vm.idEvaluacion = vm.$route.params.id
    vm.loadEvaluacion()
    vm.loadInstituciones()
    vm.loadEvaluacionesTipo()
    // vm.loadAnswer()
    // loadMemberGet()
  }
}
</script>

<style scoped>
.header-table{
  min-height: 75px;
  padding-top: 15px;
  background-color: white;
}
.estilo-p {
  color: white;
  margin-bottom: 0px
}
</style>




// WEBPACK FOOTER //
// src/components/Prueba/ShowCalificacion.vue